import { Controller } from "@hotwired/stimulus"

// Counts a click on a tool's outbound link. The href stays a plain link to
// the vendor; this only tells the site the link was opened. keepalive lets
// the request finish while the page navigates away.
export default class extends Controller {
  static values = { path: String }

  record() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.pathValue, {
      method: "POST",
      headers: { "X-CSRF-Token": token || "", "Accept": "application/json" },
      credentials: "same-origin",
      keepalive: true
    }).catch(() => {})
  }
}
